import { parkTicketInfo } from '../park-tickets/park-tickets.component';

/**
 * Datos de una compra de Parques para mostrarlos fuera del modal (carrito, detalle del itinerario).
 * El modal guarda en room.parkTicket el ticket elegido y en room.packageCode el paquete ([H|T] + [N|Q|T|D]).
 * Los items anteriores no los tienen: el ticket y el plan se deducen del texto de la tarifa.
 */

export const PARK_MEAL_LABELS: { [plan: string]: string } = {
  N: 'Sin plan de comidas',
  Q: 'Servicio Rápido',
  T: 'Servicio de Mesa',
  D: 'Deluxe',
};

/** Parque de la compra (DISNEY | UNIVERSAL | ''). Un grupo del carrito lo toma de su primer producto. */
export function parkBrand(item: any): string {
  const first = item?.rooms?.[0] || item || {};
  const raw = item?.hotelType
    || first.hotelType
    || first.room?.hotelType
    || first.payloadOriginal?.products?.[0]?.others?.hotelType
    || first.payloadUpdate?.products?.[0]?.others?.hotelType
    || '';
  const type = String(raw).toUpperCase();
  if (type === 'DISNEY' || type === 'UNIVERSAL') {
    return type;
  }
  const title = String(item?.title || '').toLowerCase();
  if (/universal|cabana bay|hard rock|portofino|royal pacific|aventura|sapphire falls|endless summer/.test(title)) {
    return 'UNIVERSAL';
  }
  return /disney/.test(title) ? 'DISNEY' : '';
}

export function parkTicketOf(item: any): any {
  return item?.room?.parkTicket || item?.parkTicket || null;
}

/** Nombre del tipo de ticket (Park Hopper, Un Parque por día...). */
export function parkTicketTitle(item: any): string {
  const ticket = parkTicketOf(item);
  return ticket ? parkTicketInfo(parkBrand(item), ticket.type)?.title || ticket.name || '' : '';
}

/** La tarifa incluye tickets de parque (aunque el item no guarde cuál se eligió). */
export function parkIncludesTicket(item: any): boolean {
  if (parkTicketOf(item)) {
    return true;
  }
  const code = String(item?.room?.packageCode || item?.packageCode || '');
  return code.charAt(0) === 'T' || /ticket/i.test(String(item?.roomType || ''));
}

/** Plan de comidas de la tarifa ('' si no se puede saber). */
export function parkMealOf(item: any): string {
  const code = String(item?.room?.packageCode || item?.packageCode || '');
  if (code.length > 1 && PARK_MEAL_LABELS[code.charAt(1)]) {
    return PARK_MEAL_LABELS[code.charAt(1)];
  }
  const text = `${item?.roomType || ''} ${item?.boardName || ''}`.toLowerCase();
  if (/quick/.test(text)) {
    return PARK_MEAL_LABELS.Q;
  }
  if (/deluxe[- ]service|deluxe dining/.test(text)) {
    return PARK_MEAL_LABELS.D;
  }
  if (/table/.test(text)) {
    return PARK_MEAL_LABELS.T;
  }
  return '';
}
